import { useEffect, useState } from 'react';
import {
  Button,
  ButtonStyles,
  LoaderType,
  NextgenImage,
  useConfig,
  useNextgenRouter,
  useSession,
  useTranslation,
} from '@nextgen-web-framework/all';
import { LoginWrapper } from '@commerce-identity-webcomponents/ui';
import { DynamicObjectInterface, RoutePaths } from '@commerce-profile-webcomponents/sdk';
import { StorageService } from '@nextgen-web-framework/core';
import { getLoginProps } from '../../../utils/Utils';
import { IRegistrationConfirmHeaderComponentProptypes } from './types/PropTypes';
import styles from './RegistrationConfirmHeaderComponent.module.scss';

const RegistrationConfirmHeaderComponent = ({
  imageUrl,
  imageLoaderType = LoaderType.CONTENTSTACK,
  imageClassName,
  className,
  heading,
  message,
  primaryButtonLabel,
  primaryButtonCallback,
  secondaryButtonLabel,
  secondaryButtonCallback,
  aboInfoNote,
  children,
  amwayId,
}: IRegistrationConfirmHeaderComponentProptypes) => {
  const [isSignupFlow, setIsSignupFlow] = useState(true);
  const t = useTranslation();
  const router = useNextgenRouter();
  const headingTxt = heading ?? t('profile.RegistrationUsersDetailsStep.thankyouMsg');
  const { isAnonymous } = useSession();
  const config = useConfig();
  useEffect(() => {
    const localstorage = StorageService.getLocalStorage();
    const sharecodeAttributes: DynamicObjectInterface = localstorage.retrieve('sharecodeAttributes');
    const fullUrl: string = sharecodeAttributes?.fullUrl;
    const signupRegex = new RegExp(RoutePaths.SIGN_UP);
    const isSignupFlowTemp = fullUrl ? signupRegex.test(fullUrl) : true;
    setIsSignupFlow(isSignupFlowTemp);
  }, []);

  return (
    <>
      <div className={`${styles['reg-confirm-header-image']} ${imageClassName}`} data-testid="reg-confirm-header-image">
        <NextgenImage
          loaderType={imageLoaderType}
          src={imageUrl}
          alt={'thank you image'}
          isRelativeURL={false}
          objectFit="contain"
        />
      </div>
      <div className={`${styles['reg-confirm-header-section']} ${className}`}>
        {children ? (
          children
        ) : (
          <>
            {headingTxt && <span className={styles['reg-confirm-header-heading']}>{headingTxt}</span>}
            {message && <span className={styles['reg-confirm-header-text']}>{message}</span>}
            {aboInfoNote && <span className={styles['reg-confirm-header-info']}>{aboInfoNote}</span>}
            {amwayId && (
              <span className={styles['reg-confirm-header-amwayid']}>
                {t('profile.AccountOrderDetails.amwayIdText')}
                <b>{amwayId}</b>
              </span>
            )}
          </>
        )}
        <div className={styles['reg-confirm-header-btn']}>
          {primaryButtonLabel && isSignupFlow && (
            <Button buttonStyle={ButtonStyles.OUTLINE} title={t(primaryButtonLabel)} onClick={primaryButtonCallback} />
          )}
          {primaryButtonLabel && !isSignupFlow && (
            <LoginWrapper
              {...getLoginProps(router.params?.locale as string, config?.DEFAULT_HOST_URL + RoutePaths.CART)}
            >
              <Button buttonStyle={ButtonStyles.SOLID} title={t('profile.RegistrationConfirmation.completePurchase')} />
            </LoginWrapper>
          )}
          {secondaryButtonLabel &&
            isSignupFlow &&
            // aboLed prospect page flow
            (isAnonymous() ? (
              <LoginWrapper
                {...getLoginProps(router.params?.locale as string, config?.DEFAULT_HOST_URL + RoutePaths.DASHBOARD)}
              >
                <Button buttonStyle={ButtonStyles.SOLID} title={t(secondaryButtonLabel)} />
              </LoginWrapper>
            ) : (
              <Button
                buttonStyle={ButtonStyles.SOLID}
                title={t(secondaryButtonLabel)}
                onClick={secondaryButtonCallback}
              />
            ))}
        </div>
      </div>
    </>
  );
};

export default RegistrationConfirmHeaderComponent;
